export default __webpack_public_path__ + "static/media/Vector.6d9e909b.svg";